import { Injectable } from '@angular/core';
import {
    ActiveState,
    EntityState,
    EntityStore,
    StoreConfig,
} from '@datorama/akita';
import { SensorModel } from '../../_models/sensor.model';

export interface SensorState
    extends EntityState<SensorModel, string>,
        ActiveState {
    ui: {
        searchInput: string;
        itemsPerPage: number;
        currentPage: number;
    };
    detail: SensorModel;
}
const initialState = {
    ui: {
        searchInput: '',
        itemsPerPage: 10,
        currentPage: 1,
    },
    detail: undefined,
};

@StoreConfig({ name: 'sensors', idKey: 'deviceId', resettable: true })
@Injectable({ providedIn: 'root' })
export class SensorsStore extends EntityStore<SensorState> {
    constructor() {
        super(initialState);
    }
}
